import { gameDrawer } from '../../services/gameDrawer';

import { randomIconsGroup, randomGeneratedIcons } from '../constants/symbolsNames';

export class SpinIconNumberProvider {
  constructor(index) {
    this.fullSet = randomGeneratedIcons.filter((num) => {
      if (+num === 9 && (index === 0 || index === 4)) {
        return false;
      }
      return num;
    });
    this.lastIcon = null;
    this.lastIconIndex = 0;
  }

  updateFullSet(index) {
    this.fullSet = randomIconsGroup[gameDrawer.randomSymbolGroupId].filter((num) => {
      if (+num === 9 && (index === 0 || index === 4)) {
        return false;
      }
      return num;
    });
  }

  getNext(columnNumber) {
    this.updateFullSet(columnNumber);
    const set = this.fullSet.filter(() => columnNumber !== 1 || columnNumber !== 3);
    this.lastIcon = set[this.lastIconIndex];
    if (this.lastIcon !== '1') {
      const newSet = randomGeneratedIcons.filter((num) => {
        if (+num === 9 && +num === 1 && (columnNumber === 0 || columnNumber === 4)) {
          return false;
        }
        return num;
      });
      this.lastIcon = newSet[Math.floor(Math.random() * newSet.length)];
    }
    this.lastIconIndex += 1;
    return this.lastIcon;
  }
}
